/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';
@use '../../../mixins';

.datepicker-fieldset {
  position: relative;
  text-align: left;
  margin: 9px 0 0 0; //space on top for label
  padding: 0 8px;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  min-width: 0;
  border-color: rgba(0, 0, 0, 0.23);
  color: rgba(0, 0, 0, 0.6);

  &.no-margin-top {
    margin-top: 0;
  }

  &:has(:hover) {
    border: variables.$color-black solid 1px;
  }

  &:has(:invalid) {
    border: variables.$color-corpuls-system-red solid 1px;
  }

  &:has(:focus) {
    border: variables.$color-orange solid 2px;
    color: variables.$color-orange; //label color
    padding-left: 7px; //prevents label from flickering right
  }

  .datepicker-legend {
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-size: 0.75rem;
    line-height: 0;
    padding: 0 4px 0 4px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: variables.$color-white;
  }

  .datepicker-input {
    font-family: monospace;
    font-size: 1.23125em;
    letter-spacing: inherit;
    color: variables.$color-black;
    border: none;
    box-sizing: content-box;
    background: none;
    height: 1.4375em;
    padding: 16px 1px 14px 1px;
    -webkit-tap-highlight-color: transparent;
    display: block;
    @include mixins.use-available-space;

    &:focus {
      outline: none;
      padding: 15px 0 13px 1px;
    }
  }

  .datepicker-input::-webkit-calendar-picker-indicator {
    width: 23px;
    height: 23px;
  }

  .datepicker-input-icons {
    position: absolute;
    right: 35px;
    top: 0;
    bottom: 0;
    justify-content: space-evenly;
    display: flex;
    align-items: center;
    padding: 0;
  }

  .icons-end {
    right: 12px;
  }

  .warning-symbol {
    margin: 8px;
  }
}
